import { FundingOpportunities } from '@platform/client';
import { Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';

interface DeleteFundingOpportunityModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: number;
  page: number;
  limit: number;
}

export const DeleteFundingOpportunityModal = (props: DeleteFundingOpportunityModalProps) => {
  const { isOpen, onClose, id, page, limit } = props;

  const queryClient = useQueryClient();

  const submitFundingOpportunity = FundingOpportunities.useDeleteFundingOpportunity({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            ...FundingOpportunities.getGetFundingOpportunitiesAdminQueryKey({ page, limit }),
          ],
        });
      },
    },
  });

  const deleteFundingOpportunity = async () => {
    submitFundingOpportunity.mutate({
      data: {
        id,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
  };

  return (
    <Modal
      variant='dialog'
      title='Delete Funding Opportunity'
      isOpen={isOpen}
      ignoreExtraPadding={true}
      headerDivision='divider'
      onClose={closeModal}
      primaryCTA={{
        text: 'Delete Funding Opportunity',
        callback: deleteFundingOpportunity,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          Are you sure you want to delete this funding opportunity?
        </div>
      </div>
    </Modal>
  );
};
